<template>
  <div class="grey-darken-1--text">
    <span v-html="$t('footer.copyright', { thisYear: new Date().getFullYear() })" />
    &verbar;
    <span
      class="text-uppercase cursor-pointer"
      @click="$router.push($localePath({ name: termsAndConditionsLink }))"
      >{{ $t('termsOfUse') }}</span
    >
    &verbar;
    <span>{{ $t('footer.issn') }}</span>
  </div>
</template>

<script>
export default {
  name: 'FooterBottomDisclaimer',
  props: {
    termsAndConditionsLink: {
      type: String,
      required: true
    }
  }
};
</script>
